__turbopack_context__.v({
  "main-nav": "xisJla_main-nav",
  "main-nav-item": "xisJla_main-nav-item",
  "main-nav-item-icon": "xisJla_main-nav-item-icon",
  "main-nav-item-title": "xisJla_main-nav-item-title",
  "main-nav-unnested-chevron": "xisJla_main-nav-unnested-chevron",
  "menu-title": "xisJla_menu-title",
  "menu-title-container": "xisJla_menu-title-container",
  "no-link-item": "xisJla_no-link-item",
  "sub-nav": "xisJla_sub-nav",
  "sub-nav-link": "xisJla_sub-nav-link",
  "sub-nav-link-description": "xisJla_sub-nav-link-description",
  "sub-nav-menu": "xisJla_sub-nav-menu",
  "sub-nav-menu-without-subtitle": "xisJla_sub-nav-menu-without-subtitle",
});
